import HomeSorting from './assets/home-images/sorting-section.jpg';
import HomeSearching from './assets/home-images/searching-section.jpg';
import HomeSudoku from './assets/home-images/sudoku-section.jpg';

import SortingBarImage from './assets/sorting-image/SortingBars.jpg';
import SortingComparisonImage from './assets/sorting-image/SortingComparison.jpg';
import SortingNavImg from './assets/sorting-image/SortingNavControl.jpg';
import SortingSectionImg from './assets/sorting-image/SortingSection.jpg';

import SearchComparison from './assets/search-image/searching-comparison.jpg';
import SudokuIntro from './assets/sudoku-images/sudoku-intro.jpg';
import SudokuUserMode from './assets/sudoku-images/sudoku-user-mode.jpg';
import SudokuUserMessage from './assets/sudoku-images/sudoku-user-message.jpg';

export const APP_NAME = 'AlgoVisualizer';
export const APP_AUTHOR = 'yunwi5';

export const HomeImages = { HomeSorting, HomeSearching, HomeSudoku };

export const SortingImages = {
    SortingBarImage,
    SortingComparisonImage,
    SortingNavImg,
    SortingSectionImg,
};

export const SearchImages = {
    SearchComparison,
};

export const SudokuImages = { SudokuIntro, SudokuUserMode, SudokuUserMessage };
